export const LLM_JUDGE_SOURCE = "llm_judge";

const PROVIDER_DISPLAY_NAMES: Record<string, string> = {
  openai: "OpenAI",
  anthropic: "Anthropic",
  google: "Google",
  azure: "Azure OpenAI",
  ollama: "Ollama",
  custom: "Custom",
  deepseek: "DeepSeek",
};

/**
 * Label for the detector/evaluator that produced a finding. Driven by the
 * explicit `source`/`provider` fields the backend returns, never by the
 * free-text reason.
 */
export const getDetectorLabel = (source?: string, provider?: string): string => {
  if (source !== LLM_JUDGE_SOURCE) {
    return "Evalight Rule Evaluator";
  }
  const providerName = provider
    ? PROVIDER_DISPLAY_NAMES[provider] ||
      provider.charAt(0).toUpperCase() + provider.slice(1)
    : "LLM";
  return `${providerName} Judge`;
};
